export const BuildTargets = {
  develop: 'develop',
  pwp: 'pwp',
  webex: 'webex',
};

export default function getBuildTarget() {
  const target = process.env.GATSBY_BUILD_TARGET;
  const options = Object.keys(BuildTargets);
  if (options.indexOf(target) === -1) {
    throw new Error(`Environment variable GATSBY_BUILD_TARGET is not set. Must be one of: ${options}`);
  }
  return process.env.GATSBY_BUILD_TARGET;
}

export function isBuildTargetDevelop() {
  return getBuildTarget() === BuildTargets.develop;
}

export function isBuildTargetPwp() {
  return getBuildTarget() === BuildTargets.pwp;
}

export function isBuildTargetWebex() {
  return getBuildTarget() === BuildTargets.webex;
}
